export default __webpack_public_path__ + "static/media/ASR_BOLGE_HIZMET_ADETLERI.fd0cc8c4.xlsx";